import { render, staticRenderFns } from "./JobForm.vue?vue&type=template&id=90189528"
import script from "./JobForm.vue?vue&type=script&lang=js"
export * from "./JobForm.vue?vue&type=script&lang=js"
import style0 from "./JobForm.vue?vue&type=style&index=0&id=90189528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports